import sileo from 'sileo';
import axios from 'source/lib/axios';

const TimelogListPayroll = new sileo.Model('hqzen', 'timelog-list');
const CompanyTimelogEmployee = new sileo.Model('hqzen', 'company-timelog-employment');
const PayrollPayslip = new sileo.Model('hqzen', 'payroll-payslip');
const TimeLogs = new sileo.Model('hqzen', 'timelogs');
const Leaves = new sileo.Model('hqzen', 'payroll-period-leaves');
const TaskAssignment = new sileo.Model('timelogging', 'task-assignments');
const PayrollIssue = new sileo.Model('hqzen', 'file-payroll-issue');
const PayrollIssuesAmazonFormData = new sileo.Model('hqzen', 'employee-payroll-issues-amazon-form-data');
const OvertimeRequest = new sileo.Model('hqzen', 'timelog-overtime-request');
const PayrollIssueDetails = new sileo.Model('hqzen', 'payroll-issue-details');
const PayrollIssueTimelogs = new sileo.Model('hqzen', 'payroll-issue-timelogs');
const EmployeeTimelogActivity = new sileo.Model('hqzen', 'employee-timelog-activity');
const GenericIssue = new sileo.Model('hqzen', 'generic-issue');
const PayrollIssueComments = new sileo.Model('hqzen', 'payroll-issue-comments');
const AdditionEmployeeCalculationItem = new sileo.Model('hqzen', 'addition-employee-calculation-item');
const SupervisorManagerPayrollIssues = new sileo.Model('hqzen', 'payroll-issues-supervisor-manager');
const OvertimeRequestComments = new sileo.Model('hqzen', 'overtime-request-comments');
const CommentAttachmentAmazonCredentials = new sileo.Model('hqzen', 'comments-amazon-form-data');
const CommentAttachments = new sileo.Model('hqzen', 'comment-attachments');
const PayrollIssueCommentMembersSeen = new sileo.Model('hqzen', 'payroll-issue-comment-members-seen');
const OvertimePolicy = new sileo.Model('hqzen', 'overtime-policy');
const EmployeePayrollPeriods = new sileo.Model('hqzen', 'employee-payroll-periods');
const HolidayColumns = new sileo.Model('hqzen', 'get-holidays');
const PayrollBreakdown = new sileo.Model('hqzen', 'employee-payroll-breakdown');

const state = {
    taskAssignments: [],
    taskCount: 0,
    isFetchingTaskAssignments: false,
    allowanceRequests: []
};

const getters = {
    allowanceRequests: state => state.allowanceRequests,
};

const mutations = {
    setTaskAssignments(state, taskAssignments) {
        state.taskAssignments = [ ...taskAssignments ];
    },

    setTaskCount(state, count) {
        state.taskCount = count;
    },

    setIsFetchingTaskAssignments(state, isFetching) {
        state.isFetchingTaskAssignments = isFetching;
    },

    setAllowanceRequests(state, allowanceRequests) {
        state.allowanceRequests = [ ...allowanceRequests ];
    },
};

const actions = {
    createOTRequest(context, data) {
        const formData = new FormData();
        formData.append('employment', data.employment);
        formData.append('reason', data.reason);
        formData.append('hours', data.hours);
        formData.append('minutes', data.minutes);
        formData.append('when', data.when);
        formData.append('type_creator', data.type_creator);
        return OvertimeRequest.objects.create(formData);
    },

    updateOTRequest(context, payload) {
        const form = new FormData();

        if (payload.data.status == 'archive') {
                form.append('status', payload.data.status);
                return OvertimeRequest.objects.update(payload.filters, form);
        } else {
            return new Promise((resolve, reject) => {
                payload.data.signature.save(async (blob) => {
                    form.append('employment', payload.data.employment);
                    form.append('reason', payload.data.reason);
                    form.append('hours', payload.data.hours);
                    form.append('minutes', payload.data.minutes);
                    form.append('when', payload.data.when);
                    form.append('status', payload.data.status);
                    form.append('platform_used', payload.data.platform_used);
                    form.append('type_creator', payload.data.type_creator);
                    form.append('remarks', payload.data.remarks);
                    form.append('location', payload.data.location);
                    form.append('signature', blob);
                    resolve(await OvertimeRequest.objects.update(payload.filters, form));
                });
            });
        }
    },

    fetchOvertimeRequestsList(context, filters) {
        return OvertimeRequest.objects.filter(filters);
    },

    fetchOvertimeRequestComments(_, filters) {
        return OvertimeRequestComments.objects.filter(filters);
    },

    createOvertimeRequestComment(_, data) {
        let form = new FormData();
        for (let item in data) {
            form.append(item, data[item]);
        }
        return OvertimeRequestComments.objects.create(form);
    },

    fetchHolidayColumnsData(context, filters) {
        return HolidayColumns.objects.filter(filters);
    },

    fetchPayrollBreakdownData(context, filters) {
        return PayrollBreakdown.objects.filter(filters);
    },

    async fetchCommentAttachmentAmazonFormData(context, filters) {
        return await CommentAttachmentAmazonCredentials.objects.filter(filters).then(amazon => {
            return amazon.amazon;
        });
    },

    createCommentAttachment(context, form) {
        return CommentAttachments.objects.create(form);
    },

    fetchCompanyTimelogEmployee(context, pk) {
        return CompanyTimelogEmployee.objects.get(pk);
    },

    fetchTimelogList(context, filters) {
        return TimelogListPayroll.objects.filter(filters);
    },

    fetchEmployeePayrollPeriods(context, filters) {
        return EmployeePayrollPeriods.objects.filter(filters);
    },

    fetchPayrollPayslip(context, pk) {
        return PayrollPayslip.objects.get(pk);
    },

    fetchTimelogDays(context, params) {
        return axios.get('hqzen/timelog-day-shift', {
            params: params
        });
    },

    /**
     * Fetches georoute logs.
     *
     * @param {any} context - The placeholder for the first parameter.
     * @param {Object} body - The request body.
     * @returns {Promise} A promise that resolves to the response from the server.
     */
    fetchGeorouteLogs(_, params) {
        return axios.get('hqzen/georoute-logs', {
            params
        });
    },

    fetchLeaveCalendarDays(context, params) {
        return axios.get('hqzen/leave-calender', {
            params: params
        });
    },

    fetchTimeLogs(context, filters) {
        return TimeLogs.objects.filter(filters);
    },

    fetchLeavesList(context, filters) {
        return Leaves.objects.filter(filters);
    },

    getPayrollIssueDetails(context, pk) {
        return PayrollIssueDetails.objects.get(pk);
    },

    fetchPayrollIssueTimelogs(context, filters) {
        return PayrollIssueTimelogs.objects.filter(filters);
    },

    resolvePayrollIssue(context, pk) {
        const data = new FormData();
        data.append('action', 'resolve');
        return PayrollIssueDetails.objects.update({ pks: pk }, data);
    },

    rejectPayrollIssue(context, data) {
        const form = new FormData();
        form.append('action', 'reject');
        form.append('remarks', data.rejectionReason);
        return PayrollIssueDetails.objects.update({ pks: data.issuePk }, form);
    },

    archivePayrollIssue(context, data) {
        const form = new FormData();
        form.append('action', data.action);
        return PayrollIssueDetails.objects.update({ pks: data.pk }, form);
    },

    async deletePayrollIssue(context, pk) {
        const data = new FormData();
        data.append('action', 'delete');
        return await PayrollIssueDetails.objects.update({ pks: pk }, data);
    },

    fetchEmployeeTimelogActivity(coontext, filters) {
        return EmployeeTimelogActivity.objects.filter(filters);
    },

    fetchGenericIssue(context, filters) {
        return GenericIssue.objects.filter(filters).then(data => {
            return data;
        });
    },

    createGenericIssue(context, filters) {
        const form = new FormData();

        form.append('details', filters.details);
        form.append('issue_type', filters.issue_type);
        form.append('payroll_period', filters.payroll_period);
        form.append('employment', filters.employment);
        return GenericIssue.objects.create(form).then((data) => data);
    },

    async fetchTaskAssignments({ commit, state }, filters) {
        commit('setIsFetchingTaskAssignments', true);

        const newTaskAssignments = await TaskAssignment.objects.filter(filters)
            .catch(error => { commit('setTaskAssignments', []); });
        commit('setTaskAssignments', newTaskAssignments.objects);
        commit('setTaskCount', newTaskAssignments.count);
        commit('setIsFetchingTaskAssignments', false);
    },

    async fetchPayrollIssueAmazonFormData(context) {
        let data = await PayrollIssuesAmazonFormData.objects.filter();
        return data.amazon;
    },

    fetchOvertimePolicy(context, filters) {
        return OvertimePolicy.objects.filter(filters);
    },

    createPayrollIssue(context, data) {
        const form = new FormData();
        form.append('new_details', data.new_details);
        form.append('type', data.type);
        form.append('payroll_period_id', data.payroll_period_id);
        form.append('employment_id', data.employment_id);
        form.append('time_logs', JSON.stringify(data.time_logs));
        form.append('time_log_date', data.date);
        form.append('shift_breaks', JSON.stringify(data.shift_breaks));
        form.append('shift_start', data.shift_start);
        form.append('shift_end', data.shift_end);
        form.append('old_time_logs', data.old_time_logs);
        form.append('attachments', JSON.stringify(data.attachments));
        form.append('end_date', data.end_date);
        return PayrollIssue.objects.create(form).then((data) => data);
    },

    fetchPayrollIssues(context, filters) {
        return PayrollIssue.objects.filter(filters);
    },

    fetchPayrollIssueComments(context, filters) {
        return PayrollIssueComments.objects.filter(filters);
    },

    updateMemberSeenPayrollIssueComments(context, data) {
        const form = new FormData();
        form.append('issue_id', data.pk);
        return PayrollIssueComments.objects.update(form);
    },

    createPayrollIssueComments(_, data) {
        const form = new FormData();
        form.append('issue_id', data.issue);
        form.append('content', data.body);
        form.append('attachments_to_add', data.attachments);
        if (data?.parent) {
            form.append('parent', data.parent);
        }
        return PayrollIssueComments.objects.create(form);
    },

    deletePayrollIssueComment(_, filters) {
        return PayrollIssueComments.objects.delete(filters);
    },

    updatePayrollIssueComment(_, data) {
        const form = new FormData();

        for (let field in data) {
            form.append(field, data[field]);
        }
        return PayrollIssueComments.objects.update({ pk: data.pk }, form);
    },

    createPayrollIssueCommentMemberSeen(context, data) {
        let form = new FormData();
        form.append('seen_by', data.seen_by);
        form.append('comment_pk', data.pk);
        return PayrollIssueCommentMembersSeen.objects.create(form);
    },

    fetchAdditionEmployeeCalculationItem(context, filters) {
        return AdditionEmployeeCalculationItem.objects.filter(filters);
    },

    fetchSupervisorManagerPayrollIssues(context, filters) {
        return SupervisorManagerPayrollIssues.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
